// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* .codeMarker {\n    background: #FFF677;\n    position:absolute;\n    z-index:20\n} */\n\n.controls {\n  text-align: right;\n}\n", "",{"version":3,"sources":["edit-doc-container.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH;EACE,iBAAiB;AACnB","file":"edit-doc-container.css","sourcesContent":["/* .codeMarker {\n    background: #FFF677;\n    position:absolute;\n    z-index:20\n} */\n\n.controls {\n  text-align: right;\n}\n"]}]);
// Exports
module.exports = exports;
